import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, stagger, item } from "@/components/site/Reveal";
import { STEPS, waLink, onWhatsApp } from "@/lib/site";

export const HowItWorks = () => {
  return (
    <section className="relative py-24 md:py-32">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Como Funciona</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Três passos para o socorro
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-14 grid md:grid-cols-3 gap-6"
        >
          {STEPS.map((s) => (
            <motion.div
              key={s.n}
              variants={item}
              className="relative border-t-2 border-white/10 pt-6 group"
            >
              <div className="font-display text-7xl md:text-8xl font-black text-white/10 group-hover:text-brand/80 transition-colors leading-none">
                {s.n}
              </div>
              <h3 className="mt-4 font-display text-2xl font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-zinc-400">{s.desc}</p>
            </motion.div>
          ))}
        </motion.div>

        <Reveal delay={0.1} className="mt-14">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="howitworks-cta"
            onClick={() => onWhatsApp("como-funciona")}
            className="group inline-flex items-center gap-3 bg-brand hover:bg-brand-hover text-white font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
          >
            Preciso de um Guincho
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
